import React from 'react'
// import PropTypes from 'prop-types'
import Svg, { Path, G } from 'svgs'

// import { colors } from '@sart/styles'

const CompanyIcon = (props) => {
  const { color, width, height } = props;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 165 96"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M41.25 82.286V96H27.5V82.286h13.75zM27.5 68.57v13.715H13.75V68.57H27.5zm82.5 0v13.715H96.25V68.57H110zM41.25 82.286V68.57h27.5V54.857h-55V27.43H27.5v13.713h55v13.715h13.75v13.714H82.5v13.715H41.25zm110-68.572V27.43L110 27.428v27.43H96.25V13.713h55zM165 27.43v13.714h-13.75V27.429H165zM82.5 13.714V27.43h-55V13.714h55zM13.75 0v13.714H0V0h13.75z"
        fill={color}
        fillRule="evenodd"
      />
    </Svg>
  )
}

export default CompanyIcon
/*Logo.defaultProps = {
  width: 121,
  height: 154,
  color: colors.exisOrange
}

Logo.propTypes = {
  color: PropTypes.string
}*/
